import React from 'react';
import {
    Flex,
    Text,
    Image,
    Link,
    useMediaQuery,
    useTheme,
} from '@chakra-ui/react';
import logoGuia from '../assets/icons/logo-guia.svg';
import fb from '../assets/icons/facebook.svg';
import ig from '../assets/icons/instagram.svg';

const Footer = () => {
    const { breakpoints } = useTheme();
    const [isGreaterThanMd] = useMediaQuery(`(min-width: ${breakpoints.lg})`);

    return ( 
        <Flex color={"#545454"} flexDirection={"column"}>
            <Flex w={"100%"} pl={10} pr={10} mb={10}>
                <Text fontSize='12px' fontWeight={'400'} textAlign={"center"}>
                    *Aplican restricciones* *Las imágenes desplegadas son únicamente de carácter ilustrativas y se presentan para una mayor comprensión de las dimensiones del inmueble para el usuario, las mismas están sujetas a cambios y modificaciones por parte del desarrollador y/o proveedor sin previo aviso. No deberá de entenderse que el inmueble se entrega amueblado y/o decorado, salvo que así se haya contratado con MORHADA por el usuario y que conste en una cotización por escrito*
                    *La información proporcionada está sujeta a términos y condiciones, así como al tratamiento de la información conforme al aviso de privacidad:
                    https://www.okboy.app/terms-conditions/
                </Text>
            </Flex>
            <Flex w={"100%"} mb={10} flexDirection={isGreaterThanMd ? "row": "column"}>
                <Flex w={isGreaterThanMd ? "33%" : "100%"} 
                    pl={isGreaterThanMd ? 10 : 0} pb={isGreaterThanMd ? 0 : 5}
                    justifyContent={isGreaterThanMd ? "initial" : "center"}>
                    <Link zIndex={"1"} href='https://grupoguia.mx/' isExternal>
                        <Image src={logoGuia} w={'134px'} h={'20px'} alt='icon4'/>
                    </Link>
                </Flex>
                <Flex w={isGreaterThanMd ? "33%" : "100%"} alignItems={"center"} 
                    justifyContent={"center"} pb={isGreaterThanMd ? 0 : 5}>
                    <Text fontSize='12px' fontWeight={'light'} textAlign={"center"}>
                        Copyright © 2023  © All Rights Reserved - Powered by Grupo guia<br />Aviso de privacidad
                    </Text>
                </Flex>
                <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "end" : "center"} pr={isGreaterThanMd ? 10 : 0}>
                    <Link zIndex={"1"} href='https://www.facebook.com/profile.php?id=100084924907179&mibextid=ZbWKwL' isExternal mb={2}>
                        <Image src={fb} w={'21px'} h={'21px'} mr={5} alt='icon4'/>
                    </Link>
                    <Link zIndex={"1"} href='https://instagram.com/morhadamx?igshid=NmE0MzVhZDY=' isExternal>
                        <Image src={ig} w={'21px'} h={'21px'} alt='icon4'/>
                    </Link>
                </Flex>
            </Flex>
        </Flex>
    );
}
 
export default Footer;